const fadeIn = {
  fromStyle: { opacity: 0, transform: 'translateX(-200%)' },
  toStyle: { opacity: 0.85, transform: 'translateX(-50%)' },
  easing: 'easeOutBack'
};

const fadeOut = {
  fromStyle: { opacity: 0.85, transform: 'translateX(-50%)' },
  toStyle: { opacity: 0, transform: 'translateX(200%)' },
  easing: 'easeOutBack'
}


export default [
  {
    text: {
		'en': "First purchased by his grandmother in 1942, Ronald Henry has lived in his family's San Antonio, Texas legacy home for 42 years since 1978. For a majority of his life, this has been the only home Ronald has ever known.<br /><span class='small font-italic'>* The source audio interview with Mr. Henry was recorded July 27th, 2021.</span>",
		'es': "Adquirido por primera vez por su abuela en 1942, Ronald Henry ha vivido en la casa heredada de su familia en San Antonio, Texas, durante 42 años desde 1978. Durante la mayor parte de su vida, esta ha sido la única casa que Ronald ha conocido<br /><span class='small font-italic'>* La grabación original de la entrevista con el señor Henry fue grabada el 27 de julio 27 del 2021.</span>"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/A.png',
    parallaxData: {
      start: 3700,
      end: 3800,
      ...fadeOut
    }
  },
  {
    text: {
		'en': "Starting in August of 2019, strange mail with offers to buy his home began arriving to Ronald's house. Inititally, Ronald didn't pay these letters any mind until...",
		'es': "A partir de agosto de 2019, comenzaron a llegar a la casa de Ronald correos extraños con ofertas para comprar su casa. Inicialmente, Ronald no prestó atención a estas cartas hasta..."
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/B.png',
    parallaxData: [
      {
        start: 3800,
        end: 3900,
        ...fadeIn
      },
      {
        start: 8300,
        end: 8400,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "...one day, he receives an envelope directly from an attorney, informing him that his client now owns 50% of the house -- this client being a trustee of the San Antonio Arts and Entertainment Revocable Trust.",
		'es': "...un día, recibe un sobre directamente de un abogado, informándole que su cliente ahora posee el 50% de la casa; este cliente es un fideicomisario del Fideicomiso Revocable de Arte y Entretenimiento de San Antonio"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/B.png',
    parallaxData: [
      {
        start: 8400,
        end: 8500,
        ...fadeIn
      },
      {
        start: 9600,
        end: 9700,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "As it turns out, Ronald's brother -- who had a 50% stake in the house -- sold his share to the trust, unbeknownst to Ronald. Now, they are coming to collect on the rest of their stake...and fast. To Ronald, it's an ambush. Who could he turn to on such short notice?",
		'es': "Resulta que el hermano de Ronald, que tenía una participación del 50% en la casa, vendió su parte al fideicomiso, sin que Ronald lo supiera. Ahora, vienen a cobrar el resto de su participación... y rápido. Para Ronald, es una emboscada. ¿A quién podría acudir en tan poco tiempo?"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/B.png',
    parallaxData: [
      {
        start: 9700,
        end: 9800,
        ...fadeIn
      },
      {
        start: 13300,
        end: 13400,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "With the walls seemingly closing in, Ronald begins to feel hopeless. However, when he notices an ad for Texas RioGrande Legal Aid (TLRA) in a senior directory and gets in contact, their message to him is simple: resist!",
		'es': "Con las paredes aparentemente cerrándose, Ronald comienza a sentirse desesperanzado. Sin embargo, cuando ve un anuncio de Texas RioGrande Legal Aid (TLRA) en un directorio para personas mayores y se pone en contacto, su mensaje para él es simple: ¡resista!"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/C.png',
    parallaxData: [
      {
        start: 13400,
        end: 13500,
        ...fadeIn
      },
      {
        start: 16500,
        end: 16600,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "While the trustee's legal representation escalate tactics and attempt to charge Ronald rent, Ronald now has his own legal protection on his side through the support of TRLA and his own community.",
		'es': "Si bien la representación legal del fideicomisario intensifica las tácticas e intenta cobrarle el alquiler a Ronald, Ronald ahora tiene su propia protección legal de su lado a través del apoyo de TRLA y su propia comunidad"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/C.png',
    parallaxData: [
      {
        start: 16600,
        end: 16700,
        ...fadeIn
      },
      {
        start: 17700,
        end: 17800,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "Now that he's not fighting alone, Ronald doesn't feel as overwhelmed. The willingness of TRLA to fight for his plight reignites hope that Ronald can win this case and resist commodification of his home as gentrification begins to overtake the neighborhood.",
		'es': "Ahora que no está luchando solo, Ronald no se siente tan abrumado. La voluntad de TRLA de luchar por su difícil situación reaviva la esperanza de que Ronald pueda ganar este caso y resistir la mercantilización de su hogar a medida que la gentrificación comienza a apoderarse del vecindario"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/D.png',
    parallaxData: [
      {
        start: 17800,
        end: 17900,
        ...fadeIn
      },
      {
        start: 26900,
        end: 27000,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "As of 2022, with the help of legal representation and advocacy, Ronald is still the homeowner of his beloved family home and the matter has been resolved amicably.",
		'es': "A partir de 2022, con la ayuda de la representación legal y la defensa, Ronald sigue siendo el propietario de su amada casa familiar y el asunto se resolvió de manera amistosa"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/E.png',
    parallaxData: [
      {
        start: 27000,
        end: 27100,
        ...fadeIn
      },
      {
        start: 27700,
        end: 27800,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "In light of his legal win, Ronald continues to advocate for other elders who want to live out their lives peacefully in their homes. He hopes to pass along his home to his son and grandchild, keeping his grandmother's legacy alive for generations to come.",
		'es': "A la luz de su victoria legal, Ronald continúa abogando por otros ancianos que quieren vivir sus vidas pacíficamente en sus hogares. Espera pasar su hogar a su hijo y nieto, manteniendo vivo el legado de su abuela para las generaciones venideras."
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/E.png',
    parallaxData: [
      {
        start: 27800,
        end: 27900,
        ...fadeIn
      },
      {
        start: 28800,
        end: 28900,
        ...fadeOut
      }
    ]
  }
];
